import { DealListItemResponse } from 'app/console-api';
import { BodyText, FlexColumn, FlexRow } from '@make-software/cspr-design';
import { TaskShortPreview } from 'app/components/management/apps/deals/view/task-short-preview';
import { AppShortPreview } from 'app/components/management/apps/deals/view/app-short-preview';
import React from 'react';
import styled from 'styled-components';

const StyledViewRow = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    width: '100%',
    marginLeft: '20px',
    flexWrap: ['wrap', 'wrap', 'unset']
  })
);

const StyledPreviewColumn = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    flex: 1,
    minWidth: '240px'
  })
);

const StyledCommonColumn = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    width: '60%'
  })
);

export const DealViewOfferStructure = ({ data }: { data: DealListItemResponse }) => {
  if (data.dealDetails.tradeType === 'exchange') {
    return (
      <StyledCommonColumn gap={32}>
      <StyledViewRow gap={32}>
        <StyledPreviewColumn gap={16}>
          <FlexColumn gap={8}>
            <BodyText size={2} scale={'xs'} variation={'darkGray'}>
              My offer
            </BodyText>
            <TaskShortPreview name={data.myOffer!.name} description={data.myOffer!.description} />
          </FlexColumn>
          <FlexColumn gap={8}>
            <BodyText size={2} scale={'xs'} variation={'darkGray'}>
              My App
            </BodyText>
            <AppShortPreview app={data.myApp} />
          </FlexColumn>
        </StyledPreviewColumn>
        <StyledPreviewColumn gap={16}>
          <FlexColumn gap={8}>
            <BodyText size={2} scale={'xs'} variation={'darkGray'}>
              Partner's offer
            </BodyText>
            <TaskShortPreview
              name={data.targetOffer!.name}
              description={data.targetOffer!.description}
            />
          </FlexColumn>
          <FlexColumn gap={8}>
            <BodyText size={2} scale={'xs'} variation={'darkGray'}>
              Partner's App
            </BodyText>
            <AppShortPreview app={data.targetApp} />
          </FlexColumn>
        </StyledPreviewColumn>
      </StyledViewRow>
      </StyledCommonColumn>
    );
  }

  if (data.dealDetails.tradeType === 'buy') {
    return (
      <StyledCommonColumn gap={32}>
        <StyledViewRow gap={32}>
          <StyledPreviewColumn gap={16}>
            <BodyText size={2} scale={'xs'} variation={'darkGray'}>
              My App
            </BodyText>
            <AppShortPreview app={data.myApp} />
          </StyledPreviewColumn>
          <StyledPreviewColumn gap={16}>
            <BodyText size={2} scale={'xs'} variation={'darkGray'}>
              Partner's App
            </BodyText>
            <AppShortPreview app={data.targetApp} />
          </StyledPreviewColumn>
        </StyledViewRow>
        <StyledViewRow gap={32}>
          <StyledPreviewColumn gap={16}>
            <FlexColumn gap={8}>
              <BodyText size={2} scale={'xs'} variation={'darkGray'}>
                My offer
              </BodyText>
              <TaskShortPreview name={data.myOffer!.name} description={data.myOffer!.description} />
            </FlexColumn>
          </StyledPreviewColumn>
        </StyledViewRow>
      </StyledCommonColumn>
    );
  }

  return (
    <StyledCommonColumn gap={32}>
      <StyledViewRow gap={32}>
        <StyledPreviewColumn gap={16}>
          <BodyText size={2} scale={'xs'} variation={'darkGray'}>
            My App
          </BodyText>
          <AppShortPreview app={data.myApp} />
        </StyledPreviewColumn>
        <StyledPreviewColumn gap={16}>
          <BodyText size={2} scale={'xs'} variation={'darkGray'}>
            Partner's App
          </BodyText>
          <AppShortPreview app={data.targetApp} />
        </StyledPreviewColumn>
      </StyledViewRow>
      <StyledViewRow gap={32}>
        <StyledPreviewColumn gap={16} style={{ width: '100%' }}>
          <FlexColumn gap={8}>
            <BodyText size={2} scale={'xs'} variation={'darkGray'}>
              Partner's offer
            </BodyText>
            <TaskShortPreview
              name={data.targetOffer!.name}
              description={data.targetOffer!.description}
            />
          </FlexColumn>
        </StyledPreviewColumn>
      </StyledViewRow>
    </StyledCommonColumn>
  );
};
